var _path;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgClock = function SvgClock(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 10,
    viewBox: "0 0 11 10",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.77051 0C3.00935 0 0.770508 2.23884 0.770508 5C0.770508 7.76116 3.00935 10 5.77051 10C8.53167 10 10.7705 7.76116 10.7705 5C10.7705 2.23884 8.53167 0 5.77051 0ZM7.74037 6.53683L7.42118 6.9721C7.41424 6.98158 7.40549 6.98959 7.39544 6.99568C7.38539 7.00176 7.37424 7.0058 7.36262 7.00757C7.35101 7.00933 7.33916 7.00878 7.32775 7.00595C7.31635 7.00312 7.30562 6.99806 7.29618 6.99107L5.4502 5.64509C5.43869 5.63683 5.42935 5.62593 5.42294 5.61331C5.41653 5.60068 5.41325 5.5867 5.41336 5.57254V2.5C5.41336 2.45089 5.45354 2.41071 5.50265 2.41071H6.03948C6.08859 2.41071 6.12877 2.45089 6.12877 2.5V5.26228L7.72028 6.41295C7.76046 6.44085 7.76939 6.49665 7.74037 6.53683Z"
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgClock, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/clock.693b4be5.svg";
export { ForwardRef as ReactComponent };